/**
 * AJ-Captcha 验证码接口
 * 直接引用项目已有的 axios 实例（推荐）
 * 如需独立使用，可改回 ./../utils/axios
 */
import request from '@/utils/request'

// 获取验证图片以及 token
export function reqGet(data) {
  return request({
    url: '/captcha/get',
    method: 'post',
    data
  })
}

// 滑动或者点选验证
export function reqCheck(data) {
  return request({
    url: '/captcha/check',
    method: 'post',
    data
  })
}
